import { TracedMaterial } from '../../../batchtracing/tracedmaterial/traced-material'
import { SerialNumberSpec, toRegexp } from '../../../batchtracing/serial-number-spec'

export class BatchTracingCtx {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public canConfigure: boolean
  public isConfigValid: boolean

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private static areTracedMaterialsValid(materials: TracedMaterial[]): boolean {
    return materials.every((tm) => this.isTracedMaterialValid(tm))
  }

  private static isTracedMaterialValid(material: TracedMaterial): boolean {
    const snConf = material?.conf?.serialNumber
    const snSpec = material?.spec?.serialNumber
    const regexTest = toRegexp(snSpec).test(snConf)
    const snOk = snSpec?.regex === null || regexTest
    const vendorOk = material?.spec?.vendors?.length === 0 || material?.conf?.vendor?.length > 0
    return snOk && vendorOk
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(public materials: TracedMaterial[]) {
    this.canConfigure = materials?.length > 0
    this.isConfigValid = BatchTracingCtx.areTracedMaterialsValid(materials)
  }
}
